<template>
  <div class="footer">
    <!--footer-->
    <div class="page-width">
      <div class="clear">
        <div class="footerGrid">
          <!-- <ul class="footer-info-container">
            <p class="footer-title">{{ $t('customer_service') }}</p>
            <li>
              <router-link to="/help-and-support"><p class="help-and-support">{{ $t('help_and_support') }}</p></router-link>
            </li>
            <li>
              <router-link to="/contact-us"><p>{{ $t('contact_us') }}</p></router-link>
            </li>
            <li>
              <router-link to="/returns-and-refunds"><p>{{ $t('return_policy') }}</p></router-link>
            </li>
          </ul>
          <ul class="footer-info-container">
            <p class="footer-title">{{ $t('get_to_know') }}</p>
            <li>
              <router-link to="/about-us"><p>{{ $t('about_us') }}</p></router-link>
            </li>
            <li>
              <router-link to="/careers"><p>{{ $t('careers') }}</p></router-link>
            </li>
          </ul>
          <ul class="footer-info-container">
            <p class="footer-title">{{ $t('terms_of_service') }}</p>
            <li>
              <router-link to="/privacy"><p>{{ $t('privacyCaps') }}</p></router-link>
            </li>
            <li>
              <router-link to="/delivery-policy"><p>{{ $t('deliveryCaps') }}</p></router-link>
            </li>
          </ul> -->
        </div>
        <afwSubscribe></afwSubscribe>
      </div>
      <div class="mobile-icons" v-if="isMobile">
        <img class="icon" src="../assets/img/wechatWhite.svg" />
        <img class="icon" src="../assets/img/facebookWhite.svg" />
        <img class="icon" src="../assets/img/instaWhite.svg" />
      </div>
    </div>
    <div class="footer-note">
      &#169;CHINATOWN SUPERMARKET
      <!-- | 
        <router-link to='/terms-of-service'>
          <span :style="{ color: 'white'}">{{ $t('terms_of_service') }}</span>
        </router-link> -->
    </div>
    <!--end footer-->
  </div>
</template>

<script>
import afwSubscribe from './afw-subscribe/afw-subscribe'

import { Config } from '../../config/default'
import { mapState } from 'vuex'
export default {
  name: "munFooter",
  data () {
    return {
      companyFB: Config.COMPANY_FB,
      companyIG: Config.COMPANY_IG
    }
  },
  components: {
    afwSubscribe
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    windowWidth: state => state.navbar.windowWidth,
    isMobile () {
      return this.windowWidth < 800
    },
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/footer.less";
@import "../assets/query/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/munFooter.vue